import apiWrapper from '../../services/apiWrapper';

const API_URL = process.env.REACT_APP_API_URL;

export const addChurch = async (churchData) => {
  try {
    const response = await apiWrapper('post', '/admin/addchurch', churchData);
    return {
      success: response.success,
      church: response.church,
    };
  } catch (error) {
    console.error('Error adding church:', error);
    return {
      success: false,
      message: error.message || 'An error occurred while adding the church. Please try again later.',
    };
  }
};